module.exports = __webpack_public_path__ + "static/img/bg2.db5fadb1.svg";